<div class="c-table__main-container" #mainContainer [class.widget]="currentSettings?.type === 'widget'">
  <div class="c-table__table-container">
    <gtd-table-header
      [limit]="pagination.limit"
      [page]="pagination.page"
      [headerActions]="currentSettings?.headerActions"
      [multiActions]="currentSettings?.checkboxesConfig?.multiActions"
      [type]="currentSettings?.type"
      [columns]="columns"
      [totalItems]="pagination.total"
      [visibilityValues]="visibilityValues"
      [titleTemplate]="titleTemplate"
      [fieldModels]="filtersModel"
      [key]="key"
      [currentSettings]="currentSettings"
      (reload)="update()"
      (onChangeFilters)="onFilterChange($event)"
      (onChangeVisibility)="onVisibilityChange($event)"
      (onChangeLimit)="onLimitChange($event)"
      (onChangePage)="onPageChange($event)"
      gtdOnboardingTips
    ></gtd-table-header>

    <ng-content select="[afterHeader]"></ng-content>

    <ng-container [ngSwitch]="currentSettings?.type">
      <div *ngIf="currentSettings?.tableAction" class="facade__action" [ngStyle]="{ width: isScroll ? 'calc(100% - 10px)' : 'initial' }">
        <div class="facade__title d-none d-sm-flex">
          {{ currentSettings?.tableAction?.title }}
        </div>
        <div class="ml-auto">
          <ng-container
            *ngIf="currentSettings?.tableAction?.component"
            p500UIComponentOutlet
            [component]="currentSettings?.tableAction?.component"
            [settings]="getActionProps(currentSettings?.tableAction)"
          >
          </ng-container>
        </div>
      </div>
      <gtd-table
        *ngSwitchCase="'table'"
        [checkboxesGroup]="checkboxesGroup"
        [key]="currentSettings?.key"
        [rows]="data?.rows"
        [rowActions]="currentSettings?.rowActions"
        [columns]="visibleColumns"
        [orderValues]="orderValues"
        [statusColorScheme]="currentSettings?.statusColorScheme"
        [statusHint]="currentSettings?.statusHint"
        (sort)="handleSort($event)"
        [emptyTableAction]="emptyTableAction"
        class="c-table__table-body"
      >
      </gtd-table>

      <gtd-table
        *ngSwitchCase="'widget'"
        [checkboxesGroup]="checkboxesGroup"
        [key]="currentSettings?.key"
        [rows]="data?.rows"
        [rowActions]="currentSettings?.rowActions"
        [columns]="visibleColumns"
        [orderValues]="orderValues"
        [statusColorScheme]="currentSettings?.statusColorScheme"
        [statusHint]="currentSettings?.statusHint"
        (sort)="handleSort($event)"
        [emptyTableAction]="emptyTableAction"
        class="c-table__table-body c-widget--table-facade--widget"
      >
      </gtd-table>

      <ng-container *ngSwitchCase="'card'">
        <div class="c-card__layout">
          <ng-container *ngFor="let row of data?.rows">
            <ng-container
              p500UIComponentOutlet
              [component]="currentSettings?.cardComponent"
              [settings]="{ row: row, actions: currentSettings?.rowActions }"
            ></ng-container>
          </ng-container>
        </div>

        <ng-container *ngIf="!data">
          <p500-ui-cube-preloader></p500-ui-cube-preloader>
        </ng-container>

        <ng-container *ngIf="data && !data?.rows.length">
          <ng-container *ngTemplateOutlet="emptyTableAction"></ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="'offer'">
        <div class="c-table__table-body c-card c-card--offer">
          <ng-container *ngFor="let row of data?.rows">
            <gtd-offer-table-row [data]="row" [columns]="visibleColumns"></gtd-offer-table-row>
          </ng-container>
        </div>

        <ng-container *ngIf="!data">
          <p500-ui-cube-preloader></p500-ui-cube-preloader>
        </ng-container>

        <ng-container *ngIf="data && !data?.rows.length">
          <ng-container *ngTemplateOutlet="emptyTableAction"></ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
  <p500-ui-pagination
    *ngIf="pagination"
    class="c-table__pagination"
    [class.widget]="currentSettings?.type === 'widget'"
    [infinityLimit]="500"
    [totalItems]="pagination.total"
    [itemsPerPage]="pagination.limit"
    [currentPage]="pagination.page"
    (currentPageChange)="onPageChange($event)"
    (limitChange)="onLimitChange($event)"
  >
  </p500-ui-pagination>
</div>

<ng-template #titleTemplate>
  <ng-container *ngIf="currentSettings?.type !== 'widget'">
    <ng-container *ngIf="tables?.length === 1">
      <span class="c-table-header__title">{{ title || currentSettings?.title }}</span>
    </ng-container>
    <ng-container *ngIf="tables?.length > 1">
      <span class="c-table-header__title -gray mr-10">{{ title }}:</span>
      <p500-ui-dropdown class="c-dropdown c-dropdown--tables" position="left">
        <ng-template p500UIDropdownHeader let-isOpen="isOpen" let-toggle="toggle">
          <div class="c-table-header__subtitle" (click)="toggle()">
            {{ currentSettings?.title }}
            <button p500-ui-button-icon class="ml-10" size="xsmall" color="primary">
              <p500-ui-icon [name]="isOpen ? 'chevron-up' : 'chevron-down'"></p500-ui-icon>
            </button>
          </div>
        </ng-template>
        <ng-template p500UIDropdownBody>
          <ng-container *ngFor="let table of tables">
            <div p500UIDropdownItem class="c-dropdown__item" (click)="onTableChange(table)">
              <span class="c-dropdown__item-text">{{ table.title }}</span>
            </div>
          </ng-container>
        </ng-template>
      </p500-ui-dropdown>
      <gtd-dot-separator></gtd-dot-separator>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="currentSettings?.type === 'widget'">
    <span class="c-widget__title">{{ title || currentSettings?.title }}</span>
  </ng-container>
</ng-template>

<ng-template #emptyTableAction>
  <gtd-empty
    class="c-table__empty-block"
    [desc]="currentSettings?.emptyTemplateAction ? dataNotFoundWithAction : dataNotFound"
    [actions]="[createActionButton]"
    [isBackground]="true"
  ></gtd-empty>
</ng-template>

<ng-template #createActionButton>
  <ng-container *ngIf="!currentSettings?.emptyTemplateAction?.description && currentSettings?.emptyTemplateAction">
    <ng-container
      p500UIComponentOutlet
      [component]="currentSettings?.emptyTemplateAction.component"
      [settings]="currentSettings?.emptyTemplateAction.props"
    ></ng-container>
  </ng-container>
</ng-template>
